<template>
  <div class="bg auth-screen">
    <div class="container pt-80 pb-50">
      <div class="card">
        <div class="card-body">
          <h2 class="card-title">Register</h2>
          <createUsernamePassword />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import createUsernamePassword from "@/components/auth/create-username-password-component";
export default {
  name: "CompleteRegistration",
  components: {
    createUsernamePassword
  }
};
</script>
<style lang="scss" src="@/assets/auth-screen.scss"></style>
